import { useTranslation } from "react-i18next";
import {
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import React from "react";

import { OlympicDto } from "../../interfaces";
import { Link, useParams } from "react-router-dom";

type TProps = OlympicDto & {
  onEditOlympic: () => void;
  onDeleteOlympic: () => void;
};
export const Olympic: React.FC<TProps> = ({
  id,
  name,
  startAt,
  endAt,
  onDeleteOlympic,
  onEditOlympic,
}) => {
  //#region hooks
  const { t, i18n } = useTranslation();
  const { courseId } = useParams<any>();

  return (
    <React.Fragment>
      <Card className="card-body">
        <UncontrolledDropdown direction="end" className="text-end">
          <DropdownToggle tag="a" id="dropdownMenuLink2" role="button">
            <i className="ri-more-fill fs-17"></i>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item edit-list"
              onClick={onEditOlympic}
            >
              <i className="ri-pencil-line me-2 align-bottom text-muted"></i>
              {t("edit")}
            </DropdownItem>
            <DropdownItem
              style={{
                alignSelf: "flex-start",
                display: "flex",
              }}
              className="dropdown-item remove-list"
              onClick={onDeleteOlympic}
            >
              <i className="ri-delete-bin-5-line me-2 align-bottom text-muted"></i>
              {t("delete")}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
        <div className="d-flex mb-2 align-items-center text-center">
          <div className="flex-grow-1">
            <h4 className="card-title mb-1">
              {i18n.language === "ar" ? name?.ar : name.en}
            </h4>
          </div>
        </div>
        <div className="d-flex mb-4 align-items-center text-center">
          <div className="flex-grow-1">
            <h6 className="card-title mb-2 fs-14">
              {t("from")} - {t("to")}{" "}
            </h6>
            <h6 className="mb-3">
              {new Date(startAt || "").toLocaleDateString()}
              {" - "}
              {new Date(endAt || "").toLocaleDateString()}
            </h6>
          </div>
        </div>
        <Link
          className="btn btn-success btn-sm"
          to={`/olympiad/questions/${courseId}/${id}`}
        >
          {t("questions")}
        </Link>
        <br />
        <Link
          className="btn btn-success btn-sm"
          to={`/olympiad/participants/${courseId}/${id}`}
        >
          {t("participants")}
        </Link>
      </Card>
    </React.Fragment>
  );
};
